<template>
  <div class="col-12 px-0 b-page b-page_height_auto">
    <div class="b-page__content">
      <main class="b-main__inner">
        <div v-if="!isReadOnlyMode" class="py-4 px-6 b-toolbar">
          <div class="b-toolbar__inner">
            <div class="mr-4 b-toolbar__item">
              <button
                class="b-btn b-btn_type_primary "
                @click="onClickCreateDiscountRate"
              >
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="plus" />
                {{$t('CONTENT.indexation.add_new_indexation')}}
              </button>
            </div>
          </div>
        </div>
        <div class="b-table b-full-table b-full-table_type_short mx-6 mt-4 mb-10">
          <div class="b-table__row b-full-table__row b-full-table__row-header">
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_lg"
            >{{$t('CONTENT.indexation.indexation_type_name')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_md"
            >{{$t('CONTENT.indexation.indexation_kind')}}</div>
          </div>
          <div class="b-table__row b-full-table__row" v-for="indexationItem in currentIndexations">
            <div class="b-table__cell b-full-table__cell b-full-table__cell_type_flex b-table__cell_width_lg">
              <button v-if="!isReadOnlyMode" type="button" class="px-0 b-btn b-btn_type_empty b-btn__icon_color_main-text" @click="onClickEditIndexation(indexationItem)">
                <dynamic-icon class="b-btn__icon" icon="edit"></dynamic-icon>
              </button>
              {{getIndexationTypeNameByTypeNumber(indexationItem.typeNumber)}}
            </div>
            <div class="b-table__cell b-full-table__cell b-table__cell_width_md">{{indexationItem.name}}</div>
          </div>
        </div>
      </main>
      <popup name="indexation-popup" height="auto" :scrollable="true">
        <div data-cy="form-label" class="b-dialog__top-panel">
          <h2>{{$t('CONTENT.indexation.create_indexation')}}</h2>
          <button class="b-btn b-btn_border_none" @click.prevent="onClickCancel">
            <dynamic-icon icon="close" />
          </button>
        </div>
        <server-error v-if="error" :error="error"></server-error>
        <IndexationEditWidget
          v-if="isShowEditDialog"
          :currentIndexation="currentIndexation"
          :allIndexationKinds="allIndexationKinds"
          @save="onClickSave($event)"
          @cancel="onClickCancel">
        </IndexationEditWidget>
      </popup>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentIndexations: {
      type: Array,
    },
    isReadOnlyMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowEditDialog: false,
      currentIndexation: null,
      error: null,
      allIndexationKinds: [
        {
          typeNumber: 1,
          typeName: `${this.$t('CONTENT.indexation.first_type')}`
        },
        {
          typeNumber: 2,
          typeName: `${this.$t('CONTENT.indexation.second_type')}`
        },
        {
          typeNumber: 3,
          typeName: `${this.$t('CONTENT.indexation.third_type')}`
        },
        {
          typeNumber: 4,
          typeName: `${this.$t('CONTENT.indexation.forth_type')}`
        }
      ]
    }
  },
  methods: {
    getIndexationTypeNameByTypeNumber(indexationTypeNumber) {
      for (let i = 0; i < this.allIndexationKinds.length; i++) {
        if(this.allIndexationKinds[i].typeNumber === indexationTypeNumber) {
          return this.allIndexationKinds[i].typeName;
        }
      }
    },
    onClickEditIndexation(indexation) {
      this.error = null;
      this.currentIndexation = indexation;
      this.isShowEditDialog = true;
      this.$modal.show('indexation-popup');
    },
    onClickCreateDiscountRate() {
      this.error = null;
      this.currentIndexation = null;
      this.isShowEditDialog = true;
      this.$modal.show('indexation-popup');
    },
    async onClickSave(data) {
      this.error = null;
      if(data.id === null) {
        try {
          await this.$store.dispatch('indexationPlugin/setIndexation', data);
          this.onClickCancel();
        } catch (e) {
          this.error = e;
        }
      } else {
        try {
          await this.$store.dispatch('indexationPlugin/editIndexation', data);
          this.onClickCancel();
        } catch (e) {
          this.error = e;
        }
      }
    },
    onClickCancel() {
      this.isShowEditDialog = false;
      this.$modal.hide('indexation-popup');
    },
  }
};
</script>

